/**** EC-564-[FE] Code injection ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
import { pickUpAddressStyles } from "@WhiteCap/Overrides/Widgets/CheckoutShipping/PickUpAddress";
import { css } from "styled-components";

pickUpAddressStyles.container = {
    gap: 20,
    css: css`
        display: contents;
        h3 {
            font-weight: 500;
            font-size: 16px;
            line-height: normal;
        }

        address[data-test-selector^="addressInfoDisplay"] {
            margin-bottom: 20px;
        }
    `,
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
